import { LegacyProductCode } from '@up2stay/up2promo-api-client';
import { cn } from '@up2stay/up2promo-ui';

/** Dot color class for behaviour chip (subtle recognition, not health). */
function behaviorDotClass(productType: string | undefined): string {
  switch (productType) {
    case LegacyProductCode.BC:
    case LegacyProductCode.FB:
      return 'bg-[color:var(--brand-500)]';
    case LegacyProductCode.GO:
      return 'bg-amber-500';
    case LegacyProductCode.IG:
      return 'bg-pink-500';
    case LegacyProductCode.TT:
      return 'bg-foreground';
    case LegacyProductCode.ME:
      return 'bg-[color:var(--ok)]';
    default:
      return 'bg-muted-foreground';
  }
}

export type ProductBehaviorChipProps = {
  productType?: string;
  label: string;
  className?: string;
};

/** Quiet behaviour/platform pill — form color lives on PhysicalFormTile only. */
export function ProductBehaviorChip({
  productType,
  label,
  className,
}: ProductBehaviorChipProps) {
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 rounded-full border border-border bg-muted/60 px-2.5 py-0.5 text-[11px] font-medium text-muted-foreground',
        className,
      )}
    >
      <span
        className={cn(
          'size-1.5 shrink-0 rounded-full',
          behaviorDotClass(productType),
        )}
        aria-hidden
      />
      {label}
    </span>
  );
}
